"use client"

import { signIn } from "next-auth/react"
import { useSearchParams } from "next/navigation"

interface SignInButtonProps {
  className?: string
  children?: React.ReactNode
  callbackUrl?: string
}

export default function SignInButton({
  className = "signin bg-interest-lighter-blue hover:bg-interest-blue cursor-pointer rounded px-3 py-1 text-sm text-white",
  children = "Sign In",
  callbackUrl,
}: SignInButtonProps) {
  const searchParams = useSearchParams()

  const handleSignIn = () => {
    // Use provided callbackUrl, or check URL params, or default to current page
    const returnUrl =
      callbackUrl ||
      searchParams.get("callbackUrl") ||
      searchParams.get("returnUrl") ||
      window.location.pathname + window.location.search

    void signIn("drupal", { callbackUrl: returnUrl })
  }

  return (
    <button onClick={handleSignIn} className={className}>
      {children}
    </button>
  )
}
